import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useOrderStore } from '@/stores/orderStore';
import { logger } from '@/utils/logger';
import { track } from '@/utils/analytics';
import { markSessionExpired } from '@/utils/sessionExpired';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const address = useOrderStore((s) => s.address);
  const userId = useOrderStore((s) => s.userId);
  const stateMissing = !address || !userId;

  useEffect(() => {
    if (stateMissing) {
      logger.warn({ area: 'state-guard' }, 'Critical state missing — redirecting to start');
      track('session_state_lost', {
        had_address: !!address,
        had_userId: !!userId,
        url: window.location.pathname,
      });
      useOrderStore.getState().reset();
      markSessionExpired();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (stateMissing) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
